import { UseQueryOptions } from '@tanstack/react-query';

import { CuredApiPaths, SortDirection } from 'models/enums';

import useQuery from '../useQuery';

import QueryKeys from './keys';

import type { AccessCentreUsersApiResponse } from 'domains/accessCentre/types';

const DEFAULT_LIMIT = 10;
const DEFAULT_OFFSET = 0;

type UseGetUsersListParams = {
    limit?: number;
    offset?: number;
    searchTerm?: string;
    sortColumn?: string;
    sortDirection?: SortDirection;
    reactQueryOptions?: UseQueryOptions<AccessCentreUsersApiResponse, Error>;
};

/** GET /users — list all users */
const useGetUsersList = ({
    limit = DEFAULT_LIMIT,
    offset = DEFAULT_OFFSET,
    searchTerm,
    sortColumn,
    sortDirection,
    reactQueryOptions,
}: UseGetUsersListParams = {}) => {
    const queryKey = QueryKeys.ACCESS_CENTRE_USERS(limit, offset, searchTerm, sortColumn, sortDirection);
    const params: {
        limit: number;
        offset: number;
        searchTerm?: string;
        sort?: string;
    } = { limit, offset };
    if (searchTerm?.trim()) {
        params.searchTerm = searchTerm.trim();
    }
    if (sortColumn && sortDirection) {
        params.sort = `${sortColumn}:${sortDirection}`;
    }
    const axiosOptions = { params };

    return useQuery<AccessCentreUsersApiResponse>(
        queryKey,
        CuredApiPaths.ACCESS_CENTRE_USERS,
        reactQueryOptions,
        axiosOptions
    );
};

export default useGetUsersList;
